/**
 * Display helpers for club rules field-edition lists.
 * Rules are stored as plain strings; prototype shows title + body.
 */

/**
 * Split a rule string into { title, body } when possible.
 * Supports "Title — body", "Title – body", or "Title: body" (short title).
 */
export function splitClubRuleText(rule) {
  const text = String(rule || '').trim();
  if (!text) return { title: '', body: '' };

  const dashMatch = text.match(/^(.{1,48}?)\s+[—–-]\s+(.+)$/s);
  if (dashMatch) {
    return { title: dashMatch[1].trim(), body: dashMatch[2].trim() };
  }

  const colonMatch = text.match(/^([^:]{1,40}):\s+(.+)$/s);
  if (colonMatch) {
    return { title: colonMatch[1].trim(), body: colonMatch[2].trim() };
  }

  return { title: text, body: '' };
}

export function listClubRuleItems(rules) {
  return (Array.isArray(rules) ? rules : [])
    .map((rule, index) => {
      const text = typeof rule === 'string' ? rule : String(rule?.title || rule?.body || '');
      if (!text.trim()) return null;
      const { title, body } = splitClubRuleText(text);
      return { n: index + 1, title, body, raw: text };
    })
    .filter(Boolean)
    .map((item, i) => ({ ...item, n: i + 1 }));
}
